import React, { useState, useContext } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import MobileBottomNav from '../components/MobileBottomNav';
import AuthContext from '../context/AuthContext';
import { Bell, Menu } from 'lucide-react';

const UserDashboard = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const { user } = useContext(AuthContext);

    return (
        <div className="flex min-h-screen bg-slate-50 font-sans text-slate-800">
            {/* Sidebar Navigation */}
            <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
            
            <div className="flex-1 flex flex-col lg:ml-0 overflow-hidden">
                {/* Clean Flat Header */}
                <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
                    <div className="px-4 sm:px-6 lg:px-8 py-3.5 flex items-center justify-between">
                        {/* Mobile Menu Button */}
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setSidebarOpen(true)}
                                className="lg:hidden p-2 rounded-xl text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors focus:outline-none"
                                aria-label="Open menu"
                            >
                                <Menu className="h-5 w-5" />
                            </button>
                            <span className="hidden lg:inline-flex items-center px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 font-bold text-[10px] border border-indigo-100 uppercase tracking-wider">
                                Workspace Active
                            </span>
                        </div>

                        {/* Right side: User info and notifications */}
                        <div className="flex items-center gap-4">
                            {/* Notifications */}
                            <Link
                                to="/dashboard/notifications"
                                className="relative p-2 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors"
                                aria-label="Notifications"
                            >
                                <Bell className="h-5 w-5" />
                                <span className="absolute top-2 right-2 w-2 h-2 bg-indigo-600 rounded-full ring-2 ring-white"></span>
                            </Link>

                            {/* User Profile */}
                            <div className="flex items-center gap-3 pl-4 border-l border-slate-200">
                                <div className="hidden sm:block text-right">
                                    <p className="text-xs font-bold text-slate-800 leading-none">
                                        {user?.name || 'User'}
                                    </p>
                                    <p className="text-[10px] text-slate-400 font-bold uppercase mt-1">
                                        {user?.internId ? `ID: ${user.internId}` : 'Student'}
                                    </p>
                                </div>
                                <Link
                                    to="/dashboard/profile"
                                    className="flex items-center justify-center w-9 h-9 rounded-full bg-indigo-600 text-white font-bold text-sm hover:bg-indigo-700 shadow-sm transition-all"
                                >
                                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                                </Link>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Main Content */}
                <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
                    <div className="max-w-7xl mx-auto w-full">
                        <Outlet />
                    </div>
                </main>

                {/* Mobile Bottom Navigation */}
                <MobileBottomNav onMenuClick={() => setSidebarOpen(true)} />
            </div>
        </div>
    );
};

export default UserDashboard;
